import { Box, Modal } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import { ModalStyleFeedback } from "../../../../common/components/ModalStyle";
import {
  getICUDischargeCheckList,
  saveICUDischargeCheckList,
} from "../../../services/cliinicalChartServices/ICUDischargeChecklistServices/ICUDischargeChecklistServices";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";

const ICUDischargeCheckList = [
  {
    id: 1,
    label: "Hemodynamically stable (BP, HR within normal limits for patient)",
    isChecked: false,
  },
  {
    id: 2,
    label:
      "Adequate respiratory function (SpO₂ ≥ 92% on ≤ 5L/min oxygen or room air)",
    isChecked: false,
  },
  {
    id: 3,
    label: "No need for vasopressors or inotropes in the last 12 hours.",
    isChecked: false,
  },
  {
    id: 4,
    label: "Resolution of acute illness for which patient got admitted to ICU.",
    isChecked: false,
  },
  {
    id: 5,
    label:
      "Mental status appropriate for discharge location (e.g., alert or back to baseline)",
    isChecked: false,
  },
  {
    id: 6,
    label: "sedation medication weaned or discontinued.",
    isChecked: false,
  },
  {
    id: 7,
    label: "Nutritional plan documented (oral, enteral, or parenteral)",
    isChecked: false,
  },
  {
    id: 8,
    label:
      "Unnecessary invasive lines removed (e.g., central line, arterial line, Foley)",
    isChecked: false,
  },
  {
    id: 9,
    label: "Transfer summary completed and available.",
    isChecked: false,
  },
  {
    id: 10,
    label: "Primary consultant and referral doctors informed",
    isChecked: false,
  },
  {
    id: 11,
    label:
      "EOLC initiated as per relative s request. Palliative care plan attached.",
    isChecked: false,
  },
];

function ICUDischargeCheckListModal(props) {
  let getLoggedUserInfo = JSON.parse(localStorage?.getItem("userInfo"));
  const {
    openICUDischargeChecklistModal,
    setOpenICUDischargeChecklistModal,
    displayInfo,
    setOpenBackdrop,
  } = props;
  const defaultValues = {
    refDoctor: null,
    patientName: "",
    age: "",
    g: "",
    p: "",
    a: "",
    lmp: null,
    riskFactor: "",
    anyothers: "",
  };

  const schema = yup.object().shape({});

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    watch,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const [ICUCheckList, setICUCheckList] = useState([]);
  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [finalObject, setFinalObject] = useState(null);

  const handleCheck = useCallback(
    (selectedItem) => {
      setICUCheckList((prevData) =>
        prevData.map((item) =>
          item?.id === selectedItem?.id
            ? { ...item, isChecked: !item.isChecked }
            : item,
        ),
      );
    },
    [ICUCheckList],
  );

  console.log("selected", ICUCheckList);

  const handleSaveClick = (data) => {
    const isAnyICUDischargedChecked = ICUCheckList.some(
      (item) => item.isChecked,
    );
    if (!isAnyICUDischargedChecked) {
      warningAlert("Please select at least one");
      return;
    }

    console.log("check Condition", isAnyICUDischargedChecked);
    let tempobj = {
      id: null,
      admissionId: displayInfo?.AdmissionId,
      checkListId: ICUCheckList?.filter((item) => item.isChecked).map(
        (item) => item.id,
      ),
      addedby: getLoggedUserInfo?.empId,
    };
    setFinalObject(tempobj);
    console.log("tempObjj", tempobj);

    setPostConfirmationModal(true);

    console.log("data from the form", data);
  };
  const onSubmit = () => {
    setPostConfirmationModal(false);
    setOpenBackdrop(true);
    saveICUDischargeCheckList(finalObject)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res?.message);
        setPostConfirmationModal(false);
        reset(defaultValues);
        setFinalObject(null);
        setOpenICUDischargeChecklistModal(false);
        setICUCheckList([]);
        setOpenBackdrop(false);
      })
      .catch((error) => {
        errorAlert(error?.data?.result?.message || error?.message);
        setOpenBackdrop(false);
      });
  };

  useEffect(() => {
    getICUDischargeCheckList()
      .then((response) => response.data)
      .then((res) => {
        if (res?.result?.length > 0) {
          setICUCheckList(res?.result);
        } else {
          setICUCheckList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setICUCheckList([]);
      });
  }, []);

  console.log("displayInfo", displayInfo);

  return (
    <>
      <Modal
        open={openICUDischargeChecklistModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={ModalStyleFeedback}
          className="w-[70%] max-h-[90%] overflow-auto rounded-lg"
        >
          <div className="flex justify-between  items-center mb-1">
            <h1 className=" font-bold text-[18px]">ICU Discharge CheckList</h1>
            <button
              type="button"
              onClick={() => {
                setOpenICUDischargeChecklistModal(false);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          {/* <CommonDivider color="" /> */}
          <form onSubmit={handleSubmit(handleSaveClick)}>
            <div className="grid grid-cols-2 xl:grid-cols-5 gap-1 bg-[#F1F1F1] p-2 rounded text-sm my-2">
              <div className="flex items-centers xl:col-span-2">
                <label className="font-semibold w-24">Patient Name</label>
                <label>&nbsp;:&nbsp;{displayInfo?.["Patient Name"]}</label>
              </div>
              <div className="flex items-centers">
                <label className="font-semibold w-12">MR No</label>
                <label>&nbsp;:&nbsp;{displayInfo?.MRNo}</label>
              </div>
              <div className="flex items-centers">
                <label className="font-semibold w-24 xl:w-12">Bed No</label>
                <label>&nbsp;:&nbsp;{displayInfo?.["Bed No"]}</label>
              </div>
              <div className="flex items-centers">
                <label className="font-semibold w-12 xl:w-7">Age</label>
                <label>&nbsp;:&nbsp;{displayInfo?.AgeYear}</label>
              </div>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "40px 1fr",
                border: "1px solid #ccc",
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                textTransform: "capitalize",
              }}
            >
              {ICUCheckList?.map((item, index) => (
                <React.Fragment key={item.id}>
                  {/* Sr.No */}
                  {/* <div
                  style={{
                    borderBottom:
                      index !== ICUCheckList?.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    borderRight: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                    background: item?.isChecked ? "#f0f8ff" : "#fff",
                  }}
                >
                  {item.id}
                </div> */}

                  {/* Checkbox */}
                  <div
                    onClick={() => handleCheck(item)}
                    style={{
                      borderBottom:
                        index !== ICUCheckList?.length - 1
                          ? "1px solid #ccc"
                          : "none",
                      borderRight: "1px solid #ccc",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: item?.isChecked ? "#f0f8ff" : "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={item?.isChecked || false}
                      // onChange={() => handleCheck(item)}
                      style={{
                        width: "10px",
                        height: "10px",
                        transform: "scale(1.5)",
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  {/* Description */}
                  <div
                    onClick={() => handleCheck(item)}
                    style={{
                      borderBottom:
                        index !== ICUCheckList.length - 1
                          ? "1px solid #ccc"
                          : "none",
                      padding: "8px",
                      cursor: "pointer",
                      background: item?.isChecked ? "#f0f8ff" : "#fff",
                    }}
                  >
                    {item.label}
                  </div>
                </React.Fragment>
              ))}
            </div>

            {/* <div className="my-2">
            <InputArea
              control={control}
              name="anyothers"
              label={"Any others"}
              minRows={3}
              maxRows={3}
            />
          </div> */}
            <div className="flex justify-end gap-3  mt-3 ">
              <CommonButton
                type="button"
                label="Reset"
                className="resetButton text-customRed border border-customRed"
                onClick={() => {
                  reset(defaultValues);
                  setICUCheckList((prevData) =>
                    prevData?.map((val) => ({ ...val, isChecked: false })),
                  );
                }}
              />
              <CommonButton
                type="submit"
                label="Save"
                className="saveButton bg-customGreen text-white "
              />
            </div>
          </form>
          {postConfirmationModal && (
            <ConfirmationModal
              confirmationOpen={postConfirmationModal}
              confirmationHandleClose={() => setPostConfirmationModal(false)}
              confirmationSubmitFunc={onSubmit}
              confirmationMsg={`Are you sure to save the ICU Discharge Checklist?`}
              confirmationButtonMsg={"Confirm"}
              confirmationLabel={"Confirmation"}
            />
          )}
        </Box>
      </Modal>
    </>
  );
}

export default ICUDischargeCheckListModal;
